import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, Link, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { PageContainer } from 'components/shared';
import CheckView from 'components/shared/views/CheckView';
import Classes from "model";
import React, { useEffect } from 'react';
import { ImageAsset, SVGAsset } from 'res';
import "./styles.css";

/**
 * @function CheckImageBackManualPage
 * @return {React.Component}
 * @exported true
 * @description A page in the "deposit a check" workflow.
 */

export default function CheckImageBackManualPage(props) {
  const { goStep } = useWorkflow() ?? {};
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  let data = { ...getDefaultPageData(), ...props.data ?? {} };
  let ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const state = { data, ui };
  const mobileDepositsVersion = data.mobileDepositsVersion ?? "";
  let timeout1;
  let timeout2;

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onCancelClick: () => goStep(0),

      onContinueClick: () => {
        const setSuccessUI = () => {
            const div = document.querySelector('.success-overlay-container');
            div.style.opacity = 1;
        };

        if(mobileDepositsVersion.version === "manual front & back images" || mobileDepositsVersion.version === "manual check images") {
            timeout1 = setTimeout(() => {
                setSuccessUI();
                
                timeout2 = setTimeout(() => {
                    clearTimeout(timeout1);
                    clearTimeout(timeout2);
                    goStep(12);
                }, 2500);
            }, 1500);
        }
      }
  });

  return(
    <PageContainer className={ `check-image-back-manual-page ${ props.className ?? "" }`} state={state} controller={controller}>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({});

export const getDefaultPageUI = (showSuccessBanner) => ({
  showSuccessBanner: { show: showSuccessBanner ?? false }
});

function PageContent() {
  const { onCancelClick, onContinueClick, ui } = useStateManager();
  const { showSuccessBanner } = ui;
  
  return (
    <div className="check-image-page-content flex-container flex-vertical">
      <div className="check-image-header flex-container flex-horizontal align-center space-between">
        <Link className="back-item-container flex-container flex-horizontal align-center" onClick={ onCancelClick }>
          <SVGAsset id="CircleXIcon" className="back-chevron left-icon inline-text-icon" />
        </Link>
        <h2 className="flex-width text-center">Check Back</h2>
        <DisabledPrompt>
          <Link>
            <SVGAsset id="QuestionMarkCircleIcon" className="help-outline-icon" />
          </Link>
        </DisabledPrompt>
      </div> 
      <CheckView checkSide="CheckBack" />
      <Link className="confirm-icon-link" onClick={ onContinueClick }>
        <SVGAsset id="CaptureIcon" className="confirm-icon" data-point="Camera_View_Check" />
      </Link>
      <div className="check-overlay-container">
        <div className="image-container flex-container flex-horizontal all-center">
          <ImageAsset id="CheckBackOverlay" className="check-overlay" />
        </div>
      </div>
      <div className="check-image-footer flex-container flex-horizontal align-center">
        <DisabledPrompt>
          <Link className="flex-container flex-horizontal align-center">
            <SVGAsset id="LightningBolt" className="lightning-icon left-icon inline-text-icon" />
          </Link>
        </DisabledPrompt>
      </div>
      {/* start: test success message. */}
      <div className={ `check-overlay-container success-overlay-container ${ showSuccessBanner.show ? "show" : "" }` }>
        <div className="overlay-item-container flex-container flex-vertical all-center">
          <div className="flex-height flex-container  all-center">
            <div className="gray-background-section flex-container flex-horizontal align-center">
              <SVGAsset id="CircleCheckmarkIcon" className="circle-check" />
              <h2>Success!</h2>
            </div>
          </div>
          <div className="placeholder-container">
            <p>[[placeholder]]</p>
          </div>
        </div>
      </div>
      {/* end: test success message. */}
    </div>
  );
}